import React from "react";
import Play from "../../../../assets/img/Play.png";
import useReveal from "../../../../hooks/useReveal";
import { Shell } from "../../../shares/landing/LandingWidgets";

/**
 * "دوره‌های آموزشی" section.
 *
 * Redesign notes:
 * The long-form introduction keeps an editorial reading measure. Courses form
 * a staggered vertical sequence instead of a generic equal three-card row.
 */

const COURSES = [
    {
        title: "ریاضیات دهم",
        description:
            "سرفصل ‏های تدریس ‏شده برای دانش‏ آموزان پایۀ دهم منطبق با کتاب ریاضی (1) است و از این حیث تفاوتی میان دانش‏ آموزان رشتۀ تجربی و ریاضی نیست. تلاش شده مباحث پیش‏ نیاز از سال‏های قبل (دورۀ متوسطۀ اول) تا حد امکان در تدریس گنجانده شود تا دانش ‏آموزان بتوانند آسان‏تر با ریاضیات کنکور ارتباط گیرند. ترتیب سرفصل‏ها به‏ گونه ‏ای انتخاب شده که آموزش بهتری صورت گیرد و فهم مطالب ساده‏ تر گردد.",
        syllabus: [
            "توابع",
            "معادله و نامعادله",
            "الگو و دنباله",
            "مثلثات",
            "توابع گویا و عبارات جبری",
            "معادله درجه دوم",
            "توابع",
            "شمارش بدون شمردن",
            "احتمالات",
            "آمار",
        ],
    },
    {
        title: "ریاضیات یازدهم",
        description:
            "سرفصل ‏های تدریس ‏شده برای دانش‏ آموزان پایۀ یازدهم منطبق با کتب ریاضی (2) ویژۀ رشتۀ تجربی و حسابان (1) ویژۀ رشتۀ ریاضی است. دانش‏ آموزان ریاضی سرفصل‏های نامشترک نظیر هندسه، آمار و احتمال را در کتب دیگر خود می‏خوانند. تدریس مطالب در این دوره به‏ گونه ‏ایست که علاوه بر مطالب سال یازدهم، هم مفاهیم سال دهم را پوشش می‏دهد و هم پیش ‏زمینه‏ ای برای سال دوازدهم مهیا می‏کند. ترتیب سرفصل‏ها به‏ گونه ‏ای انتخاب شده که آموزش بهتری صورت گیرد.",
        syllabus: [
            "توابع",
            "هندسه مختصاتی",
            "معادلات و نامعادلات گویا و گنگ",
            "معادلات درجه دوم",
            "تصاعد(الگو و دنباله)",
            "قدر مطلق و ویژگی‌های آن",
            "براکت و ویژگی‌های آن",
            "هندسه",
            "توابع نمایی و لگاریتمی",
            "مثلثات",
            "حد",
            "پیوستگی",
            "آنالیز",
            "احتمال",
            "آمار",
        ],
    },
    {
        title: "ریاضیات دوازدهم",
        description:
            "سرفصل‏های تدریس ‏شده برای دانش ‏آموزان پایۀ دوازدهم منطبق با کتب ریاضی (3) ویژۀ رشتۀ تجربی و حسابان (2) ویژۀ رشتۀ ریاضی است. دانش‏ آموزان ریاضی سرفصل ‏های نامشترک نظیر مقاطع مخروطی و احتمال را در کتب دیگر خود می‏خوانند. در این دوره، علاوه بر بیان مفاهیم و مسائل سال دوازدهم، مروری جامع بر مطالب سال‏های گذشته صورت می‏گیرد و تکنیک ‏های تست ‏زنی نیز آموزش داده می‏شود تا دانش‏ آموزان عملکرد هرچه ‏بهتری در آزمون‏های آزمایشی و کنکور سراسری داشته باشند.",
        syllabus: [
            "توابع",
            "هندسه مختصاتی",
            "مثلثات",
            "تصاعد (الگو و دنباله)",
            "قدرمطلق و ویژگی های آن",
            "ابراکت و ویژگی های آن",
            "معادلات درجه دوم",
            "بخش پذیری",
            "حد ",
            "پیوستگی",
            "مشتق",
            "کاربرد مشتق",
            "مجانب ها",
            "مقاطع مخروطی",
            "آنالیز ",
            "احتمال",
            "آمار [تکمیلی]",
            "هندسه [تکمیلی]",
        ],
    },
];

function CourseCard({ course, index }) {
    const [ref, inView] = useReveal();
    const offset = index % 2 === 0 ? "lg:me-5xl" : "lg:ms-5xl";

    return (
        <article
            ref={ref}
            className={`${inView ? "in-view" : ""} grid gap-2xl rounded-wide border border-rule-subtle bg-surface p-3xl text-start shadow-card lg:grid-cols-[minmax(20rem,0.65fr)_minmax(0,1.35fr)] ${offset} max-sm:p-xl`}
        >
            <div
                className="reveal reveal--right lg:sticky lg:top-[10rem] lg:self-start"
                style={{ "--i": 0 }}
            >
                <h3 className="text-2xl font-bold text-ink-strong">
                    {course.title}
                </h3>
                <p className="mt-md text-base font-light leading-[2] text-ink-muted">
                    {course.description}
                </p>
            </div>

            <div
                className="reveal reveal--up rounded-panel bg-surface-sunken p-xl"
                style={{ "--i": 1 }}
            >
                <h4 className="text-sm font-semibold text-ink">سرفصل‌ها</h4>
                <ul className="mt-md grid gap-x-xl gap-y-xs sm:grid-cols-2">
                    {course.syllabus.map((topic, i) => (
                        <li
                            key={`${topic}-${i}`}
                            className="flex items-start gap-xs text-base font-light text-ink-muted"
                        >
                            <span
                                aria-hidden="true"
                                className="mt-[0.9rem] h-[0.5rem] w-[0.5rem] shrink-0 rounded-pill bg-primary"
                            />
                            {topic}
                        </li>
                    ))}
                </ul>
            </div>
        </article>
    );
}

const Courses = () => {
    const [isIntroExpanded, setIsIntroExpanded] = React.useState(false);
    const [headRef, headIn] = useReveal();
    const [introRef, introIn] = useReveal();

    return (
        <section id="courses" className="py-7xl max-sm:py-6xl">
            <Shell>
                <div
                    ref={headRef}
                    className={`${headIn ? "in-view" : ""} flex items-center gap-xl`}
                >
                    <img
                        src={Play}
                        alt=""
                        className="reveal reveal--scale h-[6rem] w-[6rem] rounded-panel bg-primary-soft p-sm"
                        style={{ "--i": 0 }}
                    />
                    <h2
                        className="reveal reveal--up text-4xl font-bold leading-tight text-ink-strong max-sm:text-3xl"
                        style={{ "--i": 1 }}
                    >
                        دوره‌های آموزشی
                    </h2>
                </div>

                <div
                    ref={introRef}
                    className={`${introIn ? "in-view" : ""} mt-3xl`}
                >
                    <p
                        id="courses-introduction"
                        className={`reveal reveal--up max-w-[84ch] border-s-4 border-primary ps-2xl text-justify text-md font-light leading-[2.3] text-ink-muted max-sm:ps-lg ${
                            isIntroExpanded
                                ? ""
                                : "landing-course-intro--collapsed"
                        }`}
                        style={{ "--i": 0 }}
                    >
                        با آغاز همه ‏گیری ویروس کرونا، نقش اینترنت و فضای مجازی در آموزش
                        پررنگ ‏تر شد. گرچه پیش از این نیز بسیاری محافل آکادمیک به ‏سوی
                        مجازی‏ شدن حرکت کرده بودند، اما بیماری اخیر سرعت این روند را
                        دوچندان کرد. آموزش مجازی گاه شالودۀ اصلی کار ما را تشکیل می ‏دهد و
                        گاه به ‏عنوان مکمل در کنار آموزش حضوری عمل می ‏نماید. گرچه مزایای
                        آموزش مجازی بر کسی پوشیده نیست، اما این موضوع نباید ما را از آسیب
                        ‏شناسی آن غافل کند. دانش ‏آموز در آموزش مجازی (اعم از آنلاین و
                        آفلاین) نقش فعالانه تری ایفا می‏کند. آنچه نتیجۀ نهایی کار را می
                        ‏سازد، برنامه ‏ریزی صحیح و میزان اهمیتی است که شخص دانش‏ آموز برای
                        درس قائل می ‏شود. آموزش حضوری ارتباط بهتر و صمیمانه ‏تری میان دانش
                        ‏آموز و آموزگار برقرار می‏سازد. آموزش مجازی (به ‏ویژه نوع آفلاین)
                        از این ویژگی بی ‏بهره است اما در عوض این مزیت را دارد که تکرارپذیر
                        است و دانش‏ آموز می تواند یک فیلم آموزشی را چندین بار ببیند. این
                        خیر می تواند خود منشاء شر شود! ببینید بچه ‏ها! اگر شما مثلاً هفته
                        ‏ای 2 ساعت فیلم ریاضی می بینید (یا 2 ساعت در کلاس آنلاین ریاضی شرکت
                        می ‏کنید)، حداقل باید 2 ساعت دیگر را نیز صرف مطالعه و تست ‏زنی
                        کنید. گاهی برخی از شما از این گله دارید که در حل سؤالات امتحان‏ ها
                        دچار بی‏ دقتی می‏شوید. غالب اوقات این بی ‏دقتی نیست، بلکه کمبود
                        تسلط است و علتش هم اینست که خودتان در خانه به اندازۀ کافی مسئله حل
                        نکرده ‏اید. بگذارید یک مثالی بزنم ... اگر در امتحان در حل یک معادله
                        حین جذرگرفتن از طرفین، علامت مثبت/منفی را فراموش کردید، نام این را
                        «بی ‏دقتی» نگذارید؛ شما «تسلط کافی نداشته‏ اید» که چنین شده است.
                        راه‏ حل این مشکل هم بسیار ساده است. باید بیشتر تست بزنید و بیشتر
                        خود را با حل مسئله درگیر کنید. اگر به ‏صرف فیلم ‏دیدن و نقش
                        منفعلانۀ خود اکتفا کنید، هرگز نمی توانید به همۀ زیر و زبر کار،
                        آنچنان که باید و شاید، مسلط شوید. اگر بخواهم مفهوم صحبتم را خلاصه
                        کنم، باید بگویم دوران اجبار و آموزش معلم ‏محور گذشته است. در زمانۀ
                        فعلی نقش شما دانش ‏آموزان در یادگیری خودتان بسیار پررنگ‏ تر شده است
                        و به ‏همین‏ دلیل باید بتوانید با برنامه‏ ریزی و صرف وقت کافی در
                        راستای رسیدن به اهدافتان فعالانه تلاش کنید. همانطور که در بالا
                        گفتم، این امر به‏ ویژه در مورد درس ریاضی اهمیت وافری دارد و از این
                        حیث تفاوتی نیز میان دانش ‏آموزان رشتۀ تجربی با رشتۀ ریاضی نیست.
                        سرفصل‏ های مشترک را هر دو دسته باید به یک اندازه بلد باشند. در
                        پایان بگذارید یک توصیۀ دیگر هم بکنم. راه موفقیت یک شبه طی نمی‏ شود.
                        «فلانی 3 ماه مانده به کنکور شروع کرد و آخر سر بهترین رشته را قبول
                        شد» یک افسانه است. «با این نکات می توانید ظرف 25 ثانیه همۀ سؤالات
                        ریاضی کنکور را حل کنید» یک افسانۀ دیگر است. باید واقع ‏بین باشید،
                        مستمراً تلاش کنید و اصل مطلب را -چه در ریاضی و چه در دروس دیگر- یاد
                        بگیرید. وقتی اصل مطلب را یاد گرفتید، راه های کوتاه و آسان را هم یاد
                        خواهید گرفت.
                    </p>
                    <button
                        type="button"
                        aria-expanded={isIntroExpanded}
                        aria-controls="courses-introduction"
                        onClick={() =>
                            setIsIntroExpanded((current) => !current)
                        }
                        className="reveal reveal--up landing-cta mt-sm inline-flex min-h-[4.4rem] items-center justify-center rounded-soft px-md py-xs text-base font-medium text-primary transition-colors duration-150 hover:bg-primary-soft focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary motion-reduce:transition-none"
                        style={{ "--i": 1 }}
                    >
                        {isIntroExpanded ? "کمتر..." : "بیشتر..."}
                    </button>
                </div>

                <div className="mt-5xl flex flex-col gap-2xl">
                    {COURSES.map((course, index) => (
                        <CourseCard
                            key={course.title}
                            course={course}
                            index={index}
                        />
                    ))}
                </div>
            </Shell>
        </section>
    );
};

export default Courses;
